<mb-base-modal [headerTpl]="emptyHeader">
  <div class="content" dialog-content>
    <div class="cmp-base-inform-message">
      <div>
        <span class="mb-icon mb-icon-info-circle mb-icon-xxl"></span>
        <h5 class="inform-headline" [innerHtml]="headline | translate"></h5>
        @if (message) {
          <p class="message" [innerHtml]="message | translate"></p>
        }
        @if (actionLabel) {
          <button class="btn btn-primary" type="button" (click)="triggerAction()">
            <span [innerHtml]="actionLabel | translate"></span>
          </button>
        }
      </div>
    </div>
  </div>
</mb-base-modal>

<ng-template #emptyHeader></ng-template>
